import { Group, Paper, Text, ThemeIcon } from "@mantine/core";

// Modal içi bölüm başlığı: ikon + başlık + açıklama, sağda isteğe bağlı aksiyon. Ürün ve kategori
// formlarında birebir aynı blok iki kez duruyordu, buraya alındı.
export function FormSection({
  icon: Icon,
  title,
  description,
  action,
  children,
}) {
  return (
    <Paper withBorder radius="md" p="md">
      <Group justify="space-between" wrap="nowrap" mb="md">
        <Group gap="sm" wrap="nowrap">
          <ThemeIcon variant="light" color="chocolate" radius="md" size="md">
            <Icon size={18} />
          </ThemeIcon>
          <div>
            <Text fw={600} size="sm">
              {title}
            </Text>
            {description && (
              <Text size="xs" c="dimmed">
                {description}
              </Text>
            )}
          </div>
        </Group>
        {action}
      </Group>
      {children}
    </Paper>
  );
}
